export enum BrowserClient {
	Chrome,
	Firefox,
	Safari,
	Opera,
	Edge,
	Unknown,
}
